import React from 'react';
import { LinkButton } from '@atlaskit/button/new';
import { useIntl } from '@atlassian/jira-intl';
import { createReportUrl } from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/common/utils';
import { useFeatures } from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/controllers/features/main.tsx';
import { APP_NAMES } from '@atlassian/jira-servicedesk-common/src/utils/app-names';
import { usePageContext } from '@atlassian/jira-servicedesk-spa-commons/src/common/utils/page-context/main.tsx';
import ReportsAppBase from '@atlassian/jira-spa-apps-servicedesk-reports-base/src/ui/index.tsx';
import { MarkProductStart } from '@atlassian/jira-spa-performance-breakdown/src/utils/mark-product-start/index.tsx';
import messages from './messages';
import HomePageSpa from './ui';

const Actions = () => {
	const { formatMessage } = useIntl();
	const [{ data: pageContextData }] = usePageContext();
	const { projectContext } = pageContextData || {};
	const { projectKey } = projectContext || {};
	if (!projectKey) {
		return;
	}
	return (
		<LinkButton appearance="primary" href={createReportUrl(projectKey, '/custom/new')}>
			{formatMessage(messages.newReportButton)}
		</LinkButton>
	);
};

const ReportsHomePage = () => {
	const { data: features } = useFeatures();
	return (
		<>
			<MarkProductStart />
			<ReportsAppBase
				pageId="reports-home-page"
				appName={APP_NAMES.REPORTS_HOME_PAGE}
				pageTitle={messages.homePageTitle}
				actions={features?.hasReports ? <Actions /> : undefined}
			>
				{({ pageContext }) => <HomePageSpa pageContext={pageContext} />}
			</ReportsAppBase>
		</>
	);
};

export default ReportsHomePage;
